import request from '~/request/index.js'

/**
 * 获取当前用户的引导状态，以判断哪些引导不应该再显示
  GET /api/v1/system/onboarding/status
  接口ID：352799956
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-352799956
 */
export const getOnboardingStatusApi = () => request.get(`/api/v1/system/onboarding/status`)

/**
 * 更新引导状态，在用户完成或跳过引导时调用此接口
  POST /api/v1/system/onboarding/status
  接口ID：352799957
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-352799957
 */
export const updateOnboardingStatusApi = (data) => request.post(`/api/v1/system/onboarding/status`, data)
/**
 * 根据JD生成面试需求
  POST /api/v1/business/recruitment/generate
  接口ID：381036352
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-381036352
 */
export const subPositionNameApi = (data) => request.post(`/api/v1/business/recruitment/generate`, data)